export let okpd = [
'13.20.31 • Ткани из синтетических и искусственных комплексных нитей',
'13.95.10.110 • Материалы нетканые, кроме ватинов',
'13.95.10.190 • Изделия из нетканых материалов прочие, кроме одежды',
'13.96.16.150 • Ленты конвейерные текстильные',
'13.96.16.160 • Ткани для сит',
'13.96.16.170 • Ткани фильтровальные',
'13.96.16.190 • Материалы и изделия технического назначения прочие, не включенные в другие группировки',
'20.14.41.120 • Полиамины ациклические и их производные, соли этих соединений (ингибиторы коррозии)',
'20.14.73.190 • Масла и прочие продукты высокотемпературной перегонки каменноугольной смолы, и аналогичные продукты, в которых масса ароматических составных частей превышает массу неароматических, прочие',
'20.30.1 • Материалы лакокрасочные на основе полимеров (за исключением материалов для нанесения внутренних гладкостных покрытий, применяемых для трубной продукции)',
'20.30.2 • Материалы лакокрасочные и аналогичные для нанесения покрытий, мастики (за исключением материалов для нанесения внутренних гладкостных покрытий, применяемых для трубной продукции)',
'20.59.42.140 • Продукты аналогичные присадкам к топливу и смазочным материалам (ингибиторы коррозии)',
'20.59.59 • Продукты разные химические, не включенные в другие группировки (применительно к коксо-минеральный активатор)',
'22.19 • Изделия из резины прочие',
'22.21.1 • Мононити с размером поперечного сечения более 1 мм; прутки, стержни и фасонные профили пластмассовые',
'22.21.21.110 • Оболочки искусственные из отвержденных протеинов или целлюлозных материалов',
'22.21.21.121 • Трубы из полиэтилена для газопроводов',
'22.21.21.122 • Трубы напорные из полиэтилена',
'22.21.21.123 • Трубы канализационные и фасонные части к ним из полиэтилена',
'22.21.21.129 • Трубы полимерные жесткие прочие',
'22.21.21.130 • Трубки, шланги и рукава полимерные жесткие',
'22.21.29 • Трубы, трубки и шланги и их фитинги прочие пластмассовые',
'22.21.30.110 • Плиты, листы пластмассовые, неармированные или не комбинированные с другими материалами',
'22.21.41 • Плиты, листы, пленка и полосы (ленты) прочие пластмассовые пористые',
'22.21.42.110 • Плиты, листы прочие пластмассовые непористые',
'22.21.42.120 • Пленки прочие пластмассовые непористые',
'22.21.42.130 • Полосы (ленты) прочие пластмассовые непористые',
'22.21.42.140 • Покрытия полимерные защитные для улучшения радиационной обстановки',
'22.23.19 • Изделия пластмассовые строительные, не включенные в другие группировки',
'22.29.21 • Плиты, листы, пленка, лента и прочие плоские полимерные самоклеящиеся формы, в рулонах шириной не более 20 см',
'22.29.22 • Плиты, листы, пленка, лента и прочие плоские пластмассовые самоклеящиеся формы, прочие',
'22.29.24 • Части ламп и осветительной арматуры, световых указателей и аналогичных изделий пластмассовые',
'22.29.26.119 • Фурнитура и аналогичные пластмассовые изделия, прочие',
'23.14.1 • Стекловолокно',
'23.19.12.160 • Пеностекло в форме блоков, плит или аналогичных форм',
'23.61.11 • Черепица, плиты, кирпичи и аналогичные изделия из цемента, бетона или искусственного камня',
'23.61.12.110 • Конструкции фундаментов сборные железобетонные',
'23.61.12.120 • Конструкции каркаса зданий и сооружений сборные железобетонные',
'23.61.12.130 • Конструкции стен и перегородок сборные железобетонные',
'23.61.12.140 • Плиты, панели и настилы перекрытий и покрытий железобетонные',
'23.61.12.150 • Конструкции и детали инженерных сооружений сборные железобетонные',
'23.61.12.162 • Опоры ЛЭП, связи и элементы контактной сети электрифицированных дорог и осветительной сети',
'23.61.12.163 • Шпалы и брусья железобетонные',
'23.61.12.164 • Блоки и тюбинги для тоннелей и шахтная крепь',
'23.61.12.165 • Плиты специальные аэродромные железобетонные',
'23.61.12.169 • Конструкции и детали специального назначения сборные железобетонные прочие, не включенные в другие группировки',
'23.61.12.170 • Элементы конструктивные и архитектурно-строительные зданий и сооружений сборные железобетонные',
'23.61.12.190 • Конструкции сборные строительные железобетонные прочие',
'23.61.12.210 • Блоки и прочие изделия сборные строительные для зданий и сооружений из искусственного камня',
'23.99.12 • Изделия из асфальта или аналогичных материалов',
'23.99.19.110 • Материалы и изделия минеральные тепло- и звукоизоляционные',
'23.99.19.120 • Каолин кальцинированный',
'23.99.19.190 • Продукция минеральная неметаллическая прочая, не включенная в другие группировки',
'25.11.1 • Здания сборные из металла',
'25.11.22 • Опоры башенные и мачты решетчатые из черных металлов',
'25.11.23.110 • Конструкции и детали конструкций из черных металлов',
'25.11.23.120 • Конструкции и детали конструкций из алюминия прочие',
'25.21.11 • Радиаторы центрального отопления с неэлектрическим нагревом металлические, конвекторы',
'25.21.12 • Котлы водогрейные центрального отопления для производства горячей воды или пара низкого давления',
'25.21.13 • Части водогрейных котлов центрального отопления',
'25.30.11 • Котлы паровые, пароводогрейные и котлы паропроизводящие прочие; котлы, работающие с высокотемпературными органическими теплоносителями (ВОТ)',
'25.30.12 • Оборудование вспомогательное для использования вместе с паровыми котлами; конденсаторы для пароводяных или прочих паросиловых установок, кроме 25.30.12.111',
'25.99.29.190 • Изделия прочие из недрагоценных металлов, не включенные в другие группировки',
'26.20.12 • Терминалы кассовые, банкоматы и аналогичное оборудование, подключаемое к компьютеру или сети передачи данных',
'26.20.13 • Машины вычислительные электронные цифровые, содержащие в одном корпусе центральный процессор и устройство ввода и вывода, объединенные или нет для автоматической обработки данных',
'26.20.14 • Машины вычислительные электронные цифровые, поставляемые в виде систем для автоматической обработки данных',
'26.20.15 • Машины вычислительные электронные цифровые прочие, содержащие или не содержащие в одном корпусе одно или два из следующих устройств для автоматической обработки данных: запоминающие устройства, устройства ввода, устройства вывода ',
'26.20.16 • Устройства ввода или вывода, содержащие или не содержащие в одном корпусе запоминающие устройства ',
'26.20.17 • Мониторы и проекторы, преимущественно используемые в системах автоматической обработки данных ',
'26.20.18 • Устройства периферийные с двумя или более функциями: печать данных, копирование, сканирование, прием и передача факсимильных сообщений ',
'26.20.21 • Устройства запоминающие',
'26.20.22 • Устройства, запоминающие полупроводниковые, сохраняющие информацию при выключении питания',
'26.20.3 • Устройства автоматической обработки данных прочие',
'26.20.4 • Блоки, части и принадлежности вычислительных машин',
'26.30.11 • Аппаратура коммуникационная передающая с приемными устройствами',
'26.30.12 • Аппаратура коммуникационная передающая без приемных устройств',
'26.30.2 • Оборудование оконечное (пользовательское) телефонной или телеграфной связи, аппаратура видеосвязи',
'26.30.3 • Части и комплектующие коммуникационного оборудования',
'26.30.4 • Антенны и антенные отражатели всех видов и их части;',
'26.51.12 • Дальномеры, теодолиты и тахиметры (тахеометры); прочие геодезические, гидрографические, океанографические, гидрологические, метеорологические или геофизические инструменты и приборы',
'26.51.33 • Приборы для измерения линейных размеров ручные (включая микрометры и штангенциркули), не включенные в другие группировки',
'26.51.12.190 • Инструменты и приборы прочие, в т.ч. приборы контроля параметров (электрических) защиты от коррозии, устройства контроля скорости коррозии (УКСК)',
'26.51.43.116 • Инструменты и приборы прочие, в т.ч. приборы контроля параметров (электрических) защиты от коррозии, устройства контроля скорости коррозии (УКСК)',
'26.51.43.117  • Инструменты и приборы прочие, в т.ч. приборы контроля параметров (электрических) защиты от коррозии, устройства контроля скорости коррозии (УКСК)',
'26.51.43.120 • Инструменты и приборы прочие, в т.ч. приборы контроля параметров (электрических) защиты от коррозии, устройства контроля скорости коррозии (УКСК)',
'26.51.43.110 • Электрические измерительные приборы',
'26.51.44 • Многоканальные регистраторы',
'26.51.53.190   • Многоканальные регистраторы',
'26.51.43.120 • Системы информационные электроизмерительные, комплексы измерительно-вычислительные и установки для измерения электрических и магнитных величин',
'26.51.43.150 • Меры и приборы образцовые электрических и магнитных величин',
'26.51.43.130 • Приборы электроизмерительные щитовые аналоговые',
'26.51.43.140 • Приборы электроизмерительные лабораторные аналоговые комбинированные ',
'26.51.81 • ',
'26.51.43.110 • Устройство сопряжения СКЗ с системами телемеханики ',
'26.51.43.116 • Искатели повреждений изоляции (ИПИ)',
'26.51.43.117  • Измерители сопротивления заземлений',
'26.51.43.119 • ',
'26.51.43.120 • ',
'26.51.44 • ',
'26.51.53.190   • ',
'28.99.39.190 • ',
'26.51.43 • Приборы для измерения электрических величин без записывающего устройства',
'26.51.44 • Приборы и аппаратура для телекоммуникаций',
'26.51.45.190 • Приборы и аппаратура для измерения или контроля электрических величин прочие, не включенные в другие группировки',
'26.51.81 • ',
'26.51.51 • Термометры, пирометры, барометры, гигрометры и психрометры',
'26.51.81 • ',
'26.51.52 • Приборы для измерения или контроля расхода, уровня, давления или прочих переменных характеристик жидкостей и газов',
'26.51.81 • ',
'26.51.53.110 • Газоанализаторы или дымоанализаторы',
'26.51.81 • ',
'26.51.53.120 • Анализаторы жидкостей ',
'26.51.81 • ',
'26.51.53.130 • Анализаторы аэрозолей, твердых и сыпучих веществ',
'26.51.81 • ',
'26.51.53.140 • Приборы универсальные для определения состава и физико-химических свойств газов, жидкостей и твердых веществ',
'26.51.81 • ',
'26.51.62.190 • Машины и приборы для испытания прочих материалов и конструкций,',
'26.51.63 • Счетчики потребления или производства газа, жидкости или электроэнергии',
'26.51.84.120 • ',
'26.51.64.120 • Счетчики количества продукции (теплосчетчики, счетчики электрической энергии)',
'26.51.84.120 • ',
'26.51.64.150 • Тахометры',
'26.51.84.120 • ',
'26.51.66.111 • Динамометры общего назначения',
'26.51.66.130 • Приборы виброметрии',
'26.51.66.140 • ',
'26.51.66.190 • Вставки (муфты, фланцы) электроизолирующие для трубопроводов (ВЭИ) ',
'28.99.39.190 • ',
'26.51.66.190 • Инструменты, приборы и машины для измерения или контроля, не включенные в другие группировки:',
'26.51.66.190 • Инструменты, приборы и машины для измерения или контроля прочие, не включенные в другие группировки',
'26.51.70.110 • Термостаты',
'26.51.70.190 • Приборы автоматические регулирующие и контрольно-измерительные прочие',
'27.11.10 • Электродвигатели постоянного тока; ',
'27.11.21 • Генераторы постоянного тока;',
'27.11.22 • Электродвигатели переменного тока, многофазные, выходной мощностью более 75 кВт;',
'27.11.23 • Генераторы переменного тока (синхронные генераторы);',
'27.11.24 • Преобразователи электрические вращающиеся;',
'27.11.25 • Установки генераторные электрические и вращающиеся преобразователи; ',
'27.11.26 • Комплектующие (запасные части) генераторов',
'27.11.61.110 • ',
'27.11.62 • ',
'27.11.31 • Установки генераторные электрические и вращающиеся преобразователи;',
'27.11.32 • Установки генераторные с двигателями внутреннего сгорания с воспламенением от сжатия; ',
'27.11.41 • Трансформаторы электрические;',
'27.11.42 • Трансформаторы с жидким диэлектриком;',
'27.11.43 • Трансформаторы прочие мощностью не более 16 кВА;',
'27.11.62 • Трансформаторы прочие мощностью более 16 кВА;',
'27.11.41 • Трансформаторы тока и трансформаторы напряжения',
'27.11.50 • Элементы балластные для газоразрядных ламп или трубок; статические электрические преобразователи; прочие катушки индуктивности ',
'27.11.50.120 • Преобразователи электрические статические для привода ',
'27.11.50.120 • Преобразователи электрические статические (выпрямители, инверторы, конверторы, СБП)',
'27.11.61 • Части электродвигателей и генераторов',
'27.11.50.120 • Станции катодной защиты (СКЗ) ',
'27.12.31 • Станции дренажной защиты (СДЗ)',
'27.12.32 • Модульные станции катодной защиты (МСКЗ)',
'27.12.10.110 • Аппаратура распределительная и регулирующая электрическая',
'27.12.10.120 • комплектные распределительные устройства на напряжение свыше 1000В, камеры сборные, пункты секционирования',
'27.12.10.140 • Устройства коммутации или защиты электрических цепей на',
'27.12.10.150 • напряжение более 1 кВ:',
'27.12.10.190 • Выключатели, контакторы и реверсоры переменного тока высокого напряжения (выключатели силовые высоковольтные);',
'27.12.10.130 • Разрядники высоковольтные',
'27.12.21 • Предохранители плавкие на напряжение не более 1 кВ',
'27.12.22 • Устройства для коммутации или защиты электрических цепей на напряжение не более 1 кВ',
'27.12.23 • Выключатели автоматические на напряжение не более 1 кВ',
'27.12.24 • Устройства защиты электрических цепей на напряжение не более 1кВ, не включенные в другие группировки',
'27.12.32 • Реле на напряжение не более 1 кВ',
'27.12.40 • Панели и прочие комплекты электрической аппаратуры коммутации или защиты на напряжение более 1 кВ',
'28.99.39.190    • Системы коррозионного мониторинга, в том числе подсистемы коррозионного мониторинга ПКМ, совмещенные со станциями катодной защиты СКЗ (в т.ч. числе узлы и компоненты)',
'27.20.11 • Аккумуляторы свинцовые, кроме используемых для запуска поршневых двигателей',
'27.20.12 • Батареи аккумуляторные никель-кадмиевые',
'27.20.21 • Батареи аккумуляторные никель-железные',
'27.20.22 • Батареи аккумуляторные никель-металл-гидридные',
'27.20.23 • Батареи аккумуляторные литий-ионные',
'27.20.24 • Части электрических аккумуляторов, включая сепараторы',
'27.32.13.135 • Провода для воздушных линий электропередач',
'27.32.14.120 • ',
'27.32.14.130 • ',
'27.32.11 • Провода обмоточные изолированные',
'27.32.12 • Кабели коаксиальные и прочие коаксиальные проводники электрического тока',
'27.32.13 • Провода и кабели электронные и электрические на напряжение не более 1кВ ',
'27.32.13.124 • Кабели силовые гибкие общего назначения',
'27.32.13.143 • Кабели контрольные',
'27.32.13.110 • Кабели силовые для стационарной прокладки на напряжение до 1 кВ',
'27.32.13.190 • Кабели, провода и другие проводники прочие на напряжение до 1 кВ',
'27.32.14.110 • Проводники электрические прочие на напряжение более 1 кВ',
'27.32.14.190 • Провода силовые для стационарной прокладки на напряжение свыше 1000В ',
'27.33.11 • Выключатели на напряжение не более 1 кВ',
'27.33.13 • Разъемы, розетки и прочая аппаратура коммутации или защиты электрических цепей, не включенная в другие группировки',
'27.33.14 • Арматура электроизоляционная из пластмасс',
'27.40.12 • Лампы накаливания галогенные с вольфрамовой нитью, кроме ультрафиолетовых или инфракрасных ламп ',
'27.40.13 • Лампы накаливания мощностью 100 - 200 Вт, не включенные в другие группировки ',
'27.40.14 • Лампы накаливания прочие, не включенные в другие группировки ',
'27.40.15 • Лампы газоразрядные; ультрафиолетовые и инфракрасные лампы; дуговые лампы; светодиодные лампы ',
'27.40.21 • Светильники и фонари электрические переносные, работающие от встроенных батарей сухих элементов, аккумуляторов, магнето ',
'27.40.23 • Светильники и осветительные устройства неэлектрические ',
'27.40.24 • Указатели светящиеся, световые табло и подобные им устройства ',
'27.40.33 • Прожекторы и аналогичные светильники узконаправленного света ',
'27.40.39 • Светильники и осветительные устройства прочие, не включенные в другие группировки ',
'27.40.4 • Части ламп и осветительного оборудования',
'27.52.13 • Воздухонагреватели или распределительные устройства для подачи горячего воздуха неэлектрические из черных металлов, не включенные в другие группировки',
'27.90.11 • Машины электрические и аппаратура специализированные',
'27.90.2 • Панели индикаторные на жидких кристаллах или на светоизлучающих диодах; электрическая аппаратура звуковой или световой сигнализации',
'27.90.4 • Оборудование электрическое прочее, не включенное в другие группировки (включая магниты электрические; муфты и тормоза электромагнитные; захваты подъемные электромагнитные; ускорители частиц электрические; генераторы сигналов электрические)',
'27.90.5 • Конденсаторы электрические',
'28.11.12 • Дизели тепловозные ',
'28.11.13.120 • Дизели промышленные',
'28.11.13.130 • ',
'28.11.13.190 • ',
'28.11.21 • ',
'28.11.22 • Двигатели внутреннего сгорания поршневые с воспламенением от сжатия прочие, не включенные в другие группировки',
'28.11.3 • Турбины паровые прочие ',
'28.11.4 • Турбины гидравлические и водяные колеса',
'28.11.23 • Газотурбинные двигатели (ГТД)',
'28.11.33 • ',
'28.12.11 • Двигатели гидравлические и пневматические линейного действия (цилиндры)',
'28.12.12 • Двигатели гидравлические и пневматические вращательного действия',
'28.12.13 • Насосы гидравлические',
'28.12.14 • Клапаны гидравлические и пневматические ',
'28.13.11 • Насосы топливные, смазочные насосы (лубрикаторы), насосы для охлаждающей жидкости и бетононасосы',
'28.13.12 • Оборудование гидравлическое и пневматическое силовое',
'28.13.13 • Насосы роторные объемные прочие для перекачки жидкостей',
'28.13.14 • Насосы центробежные подачи жидкостей прочие;',
'28.13.21 • Насосы вакуумные',
'28.13.22 • Насосы воздушные ручные или ножные',
'28.13.25 • Центробежные компрессоры (ЦБК), ',
'28.13.27 • Осевые компрессоры (ОК), ',
'28.13.28 • Осецентробежные компрессоры, ',
'28.13.21 • Компрессорное оборудование (вспомогательные обеспечивающие системы)',
'28.13.22 • ',
'28.13.23 • ',
'28.13.24 • ',
'28.13.25 • ',
'28.13.26 • ',
'28.13.27 • ',
'28.13.28 • ',
'28.13.26 • Компрессоры поршневые объемные',
'28.13.3 • Части насосов и компрессоров',
'28.14.11 • Арматура (краны, клапаны и другая аналогичная арматура) для трубопроводов, сосудов, котлов, цистерн, баков и аналогичных емкостей',
'28.14.13 • Арматура запорная для управления процессом (задвижки, краны, клапаны запорные, затворы дисковые, пакеры заколонные, пакеры внутриколонные  и другая арматура)',
'28.14.20 • Приводы и механизмы исполнительные, основные узлы, детали, комплектующие арматуры',
'28.21.12 • Печи и камеры промышленные или лабораторные неэлектрические, включая мусоросжигательные печи, кроме хлебопекарных печей',
'28.22.13 • Домкраты; подъемные механизмы, используемые для подъема транспортных средств ',
'28.22.14.120 • Краны грузоподъемные ',
'28.22.14.140 • Краны портальные ',
'28.22.14.150 • Машины самоходные и тележки, оснащенные подъемным краном ',
'28.22.14.160 • Краны-штабелеры ',
'28.22.14 • Деррик-краны; подъемные краны; подвижные подъемные фермы, портальные краны, самоходные или несамоходные машины, оснащенные подъемным краном',
'28.25.11 • Теплообменники и машины для сжижения воздуха или прочих газов',
'28.25.11.110 • Аппараты воздушного охлаждения газа',
'28.25.12.110 • Кондиционеры промышленные',
'28.25.12.190 • Оборудование для кондиционирования воздуха прочее, не включенное в другие группировки ',
'28.25.13.110 • Оборудование холодильное и морозильное, кроме бытового оборудования',
'28.25.13.119 • Оборудование холодильное прочее',
'28.25.13.120 • Насосы тепловые, кроме бытовых насосов',
'28.25.14  • Фильтрующие элементы устройств подготовки газа на КС;',
'28.25.14.120 • Оборудование и установки для фильтрования или очистки газов, не включенные в другие группировки',
'28.25.14.122 • ',
'28.25.14.123 • ',
'28.25.14.124 • ',
'28.25.14.125 • ',
'28.25.14.126 • ',
'28.25.14.129 • ',
'28.25.14 • Фильтрующие элементы подготовки циклового воздуха ГПА;',
'28.25.14.110 • Оборудование и установки для фильтрования или очистки воздуха',
'28.25.14.111 • ',
'28.25.14.112 • ',
'28.25.14.119 • ',
'28.25.14.120 • ',
'28.25.14.121 • ',
'28.25.14.122 • ',
'28.25.14.123 • ',
'28.25.14.124 • ',
'28.25.14.125 • ',
'28.25.14.126 • ',
'28.25.14.129 • ',
'28.25.14 • Воздухоочистительные устройства (ВОУ, КВОУ)',
'28.25.14.110 • ',
'28.25.14.111 • ',
'28.25.14.113 • ',
'28.25.14.112 • ',
'28.25.14.119 • ',
'28.25.14.120 • ',
'28.25.14.121 • ',
'28.25.14.122 • ',
'28.25.14.123 • ',
'28.25.14.124 • ',
'28.25.14.125 • ',
'28.25.14.126 • ',
'28.25.14.129 • ',
'28.25.20 • Вентиляторы, кроме настольных, напольных, настенных, оконных, потолочных или вентиляторов для крыш',
'28.25.30 • Части холодильного и морозильного оборудования и тепловых насосов',
'28.29.11 • Генераторы для получения генераторного или водяного газа; ацетиленовые и аналогичные газогенераторы; установки для дистилляции или очистки',
'28.29.12.110 • Оборудование для фильтрования или очистки воды',
'28.29.12.130 • Фильтры жидкостные',
'28.29.12.140 • Фильтры и сепараторы для гидроприводов',
'28.29.12.190 • Оборудование и установки для фильтрования или очистки жидкостей прочие, не включенные в другие группировки',
'28.92 • Оборудование для добычи полезных ископаемых подземным и открытым способами и строительства (в части оборудования устьев скважин, промыслового, внутрискважинного, для ремонта скважин, СПД)',
'28.99.39.190 • Оборудование внутрискважинное и инструмент для его обслуживания',
'28.92.27.190 • Оборудование ремонта скважин:',
'28.99.52 • Оборудование для СПД:',
'28.99.39.190 • Затрубные уплотнения;',
'28.92.61.110 • Оборудование внутрискважинное: ',
'28.99.39.190 • Агрегаты газоперекачивающие, в том числе оборудование для ГПА:',
'28.99.39.190 • Турбодетандерные агрегаты ',
'28.99.39.190 • Камеры приема – запуска внутритрубных устройств (в том числе затворы концевые, люк – лазы, мобильные комплексы обеспечения работ по внутритрубной диагностике магистральных газопроводов )',
'28.99.39.190 • Блочно-комплектное оборудование (МКС, МКУ, МАС, ДКС)',
'28.99.39.190 • Сосуды и аппараты, работающие под избыточным давлением ',
'28.99.39.190 • Устьевое оборудование (арматура фонтанная, колонные головки, елки фонтанные, трубные головки, обвязки колонные и т.п.), в т.ч. запчасти и ЗИП',
'28.99.39.190 • Блоки технологические',
'28.99.39.190 • Оборудование устьевое:',
'28.99.39.190 • Арматура фонтанная и нагнетательная и оборудование устьевое, в том числе: ',
'28.99.39.190 • Оборудование для системы подводной добычи углеводородов: ',
'28.99.39.190 • Оборудование для системы подводной добычи углеводородов: ',
'28.99.39.190 • Оборудование для системы подводной добычи углеводородов: ',
'28.99.39.190 • Оборудование для системы подводной добычи углеводородов: ',
'28.99.39.190 • Оборудование для системы подводной добычи углеводородов: ',
'28.99.39.190 • Оборудование для системы подводной добычи углеводородов: ',
'28.99.39.190 • Оборудование внутрискважинное, в том числе:',
'28.99.39.190 • Арматура фонтанная: Подвеска насосно-компрессорных труб',
'28.99.39.190 • Блочно-комплектное технологическое оборудование: УПТГ, БПТГ, УПТПГ, УПТПИГ, УПИГ и их компоненты',
'28.99.39.190 • Блочно-комплектное технологическое оборудование  Газораспределительные станции (АГРС, ГРС и их компоненты)',
'28.99.39.190 • Устройства сужающие быстросъемные (УСБ)',
'28.99.39.190 • Оборудование для проведения испытаний',
'28.99.39.190 • Блочно-комплектное технологическое оборудование (АГНКС и их компоненты) ',
'28.99.39.190 • Комплектное оборудование систем теплоснабжения опасных производственных объектов (котельные)',
'28.99.39.190 • Факельные установки',
'28.99.39.190 • Автоматизированные системы управления технологическими процессами (АСУ ТП)',
'28.99.39.190 • Универсальные многофункциональные модули',
'28.99.39.190 • Унифицированный комплект системы электрохимической защиты от коррозии',
'28.99.52 • Части прочего оборудования специального назначения',
'42.21.13 • Системы оросительные (каналы); водоводы и водопроводные конструкции; водоочистные станции, станции очистки сточных вод и насосные станции'
];

export let docType = [
    'ГОСТ',
    'ГОСТ Р',
    'ТУ',
    'СТО',
]